import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

export const gtipApi = createApi({
  reducerPath: 'gtipApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['gtip'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    searchGtip: builder.query({
      query: ({ searchTerm }) => ({
        method: 'GET',
        path: `PublicData/Gtipsearch?q=${encodeURIComponent(searchTerm)}`,
      }),
      providesTags: ['gtip'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const gtipApiReducerName = gtipApi.reducerPath;
export const gtipApiReducer = gtipApi.reducer;
export const gtipApiMiddleware = gtipApi.middleware;

export const {
  useSearchGtipQuery,
  useLazySearchGtipQuery,
} = gtipApi;
